import { Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const daysSince = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  const start = new Date(y, m - 1, d);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.round((today - start) / 86400000));
};

const span = (days, t) => {
  if (days === 0) return t("lfm_today");
  if (days < 14) return `${days} ${t(days === 1 ? "lfm_day" : "lfm_days")}`;
  if (days < 60) return `${Math.floor(days / 7)} ${t("lfm_weeks")}`;
  const mo = Math.floor(days / 30);
  return `${mo} ${t(mo === 1 ? "lfm_month" : "lfm_months")}`;
};

export const MissingDuration = ({ listing }) => {
  const { t } = useLanguage();
  if (!listing?.lf_type || !listing.lf_date || listing.reunited_at) return null;
  const days = daysSince(listing.lf_date);
  const lost = listing.lf_type === "lost";
  const tone = !lost ? "bg-emerald-600 text-white" : days < 3 ? "bg-red-600 text-white" : days <= 14 ? "bg-amber-400 text-amber-950" : "bg-slate-600 text-white";
  const text = days === 0
    ? t(lost ? "lfm_missing_today" : "lfm_found_today")
    : lost ? `${t("lfm_missing")} ${span(days, t)}` : `${t("lfm_found")} ${span(days, t)} ${t("lfm_ago")}`.trim();
  return (
    <span data-testid={`lf-duration-${listing.id}`} data-days={days}
      className={`inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-md shadow ${tone}`}>
      <Clock size={12} /> {text}
    </span>
  );
};
